<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="navMenuItems" />
  </div>
</template>

<script>
import allNavMenuItems from '@/navigation/horizontal'
import { computed } from '@vue/composition-api'
import store from '@/store'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

const HIDDEN_WHEN_ZOOM = ['softphone', 'chat']

export default {
  components: {
    HorizontalNavMenuItems,
  },
  setup() {
    // Softphone/Chat are replaced by Zoom embed when zoomEnabled
    const navMenuItems = computed(() => {
      const zoomEnabled = Boolean(store.getters['User/user']?.zoomEnabled)
      if (!zoomEnabled) return allNavMenuItems
      return allNavMenuItems.filter(item => !HIDDEN_WHEN_ZOOM.includes(item.action))
    })

    return {
      navMenuItems,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
